var $0ca66da2cd91e086$exports = {};
$0ca66da2cd91e086$exports = {
    "loading": `Laadimine...`,
    "loadingMore": `Laadi rohkem...`
};


export {$0ca66da2cd91e086$exports as default};
//# sourceMappingURL=et-EE.mjs.map
